import { render, staticRenderFns } from "./GenericTableWrappedInDialog.vue?vue&type=template&id=c4534a8c&lang=pug&"
import script from "./GenericTableWrappedInDialog.vue?vue&type=script&lang=ts&"
export * from "./GenericTableWrappedInDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports